import { SharedCoreI18nEn } from '@greatmindsorg/assess-web-core-lib';
export default {
  common: {
    appName: 'Student Tool',
    navigation: {
      home: 'To Do',
      reports: 'Reports',
      find: 'Find',
      mathManipulative: 'Tools'
    },
    ...SharedCoreI18nEn
  }
};